import styled from 'styled-components';

import { Cron, CronError } from 'react-js-cron';
import { Alert } from '@mui/material';

const Container = styled.div`
  height: 100%;
  width: 100%;

  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .react-js-cron {
    color: ${({ theme }) => theme.text.standard} !important;

    *,
    *:hover,
    *:active,
    *:focus,
    *:visited,
    *::before,
    *::after {
      color: ${({ theme }) => theme.text.standard} !important;
    }
  }

  .ant-select-selector,
  .ant-select-dropdown {
    height: 100%;
    min-width: 90px;
    background-color: ${({ theme }) => theme.background.standard} !important;
  }

  [data-testid='custom-select-months'] {
    .ant-select-selector {
      min-width: 150px;
    }
  }

  [data-testid='custom-select-month-days'] {
    .ant-select-selector {
      min-width: 150px;
    }
  }

  [data-testid='custom-select-week-days'] {
    .ant-select-selector {
      min-width: 150px;
    }
  }
`;

interface Props {
  value: string;
  setValue: React.Dispatch<string>;
  error: CronError;
  onError: React.Dispatch<CronError>;
}

export const formatCronExpression = (expression: string) => {
  const parts = expression.split(' ');
  const formattedParts = parts.map((part) => {
    return part.padEnd(3, ' ');
  });

  return formattedParts.join(' ');
};

export const CronSchedule: React.FC<Props> = ({ value, setValue, error, onError }) => {
  return (
    <Container>
      <Cron
        value={value}
        setValue={setValue}
        clockFormat='12-hour-clock'
        allowEmpty='never'
        humanizeLabels
        humanizeValue
        onError={onError}
        clearButton={false}
      />
      {error && <Alert severity='error'>{error.description}</Alert>}
    </Container>
  );
};
